import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  cellNumber: '',
  role: '',
  readTermsAndCondition: false
};
const signupSlice = createSlice({
  name: 'signupSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setDataOnSignup(state, action) {
      state.email = action.payload?.email;
      state.cellNumber = action.payload?.cellNumber;
      state.role = action.payload?.role;
      state.readTermsAndCondition = action.payload?.readTermsAndCondition;
    }
  }
});
export const { setDataOnSignup } = signupSlice.actions;
export default signupSlice.reducer;
